import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Modal from "react-overlays/Modal";
import UserContext from "../context/user";
import Icon from "./icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const DeleteSubmissionModal = ({ show, closeModal, onDeleteSubmission, surveyId, id, labels }) => {
  const { callApi } = useContext(UserContext);
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(
    ({ surveyId, id }) => callApi(`/survey/${surveyId}/answer/${id}`, { method: "DELETE" }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["answers", surveyId]);
        onDeleteSubmission();
        closeModal();
      },
    }
  );

  const deleteSubmission = async () => {
    await deleteMutation.mutateAsync({ surveyId, id });
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_MODAL_DELETE_SUBMISSION ||
              "Are you sure you want to delete your submission?"}
          </h1>
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_DISCARD || "Discard"}
            </button>
            <button className="button primary" onClick={deleteSubmission}>
              {deleteMutation.isLoading && <span className="loading-spinner" />}
              {labels?.WELFARE_DELETE_SUBMISSION || "Delete submission"}
              <Icon name="trash" />
            </button>
          </div>
          {deleteMutation?.isError && (
            <p className="modal__error">
              {labels?.WELFARE_ERROR_DELETING_SUBMISSION || "Error deleting submission"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default DeleteSubmissionModal;
